import { Injectable } from "@angular/core";
import { Constants } from "@app/env";

@Injectable({
  providedIn: "root",
})
export class GoogleRecaptchaService {
  constructor(public constants: Constants) {}
  /**
   * Gets a Google ReCAPTCHA token.
   * @returns A Promise that resolves with the ReCAPTCHA token.
   */
  getRcToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      (window as any).grecaptcha.ready(() => {
        try {
          (window as any).grecaptcha
            .execute("6Lct-B8pAAAAAH7zIKSwhlTeBSqKzRmErXRax5Iy", {
              action: "login",
            })
            .then(
              (token) => {
                resolve(token);
              },
              (error) => {
                reject(error);
              }
            );
        } catch (err) {
          reject(err);
        }
      });
    });
  }
}
